import PropTypes from 'prop-types';

import Logo from '../Logo';
import * as Header from './StandaloneHeader.style';

/**
 * StandaloneHeader component for standalone tool pages
 *
 * Displays a header with:
 * - Velo logo on the left
 * - Tool title and subtitle on the right
 *
 * @param {object} props - Component props
 * @param {string} props.title - The title of the tool (e.g., 'Market Analysis Tool')
 * @param {string} [props.subtitle] - Optional subtitle/description
 * @param {string} [props.logoSrc] - Custom logo source (defaults to white Velo logo)
 * @param {number} [props.logoHeight] - Custom logo height (defaults to 19)
 * @returns {ReactElement} The StandaloneHeader component
 */
export default function StandaloneHeader({
  title,
  subtitle,
  logoSrc = '/s2/logo/zb-velo-full-white.svg',
  logoHeight = 19
}) {
  return (
    <Header.Background>
      <Header.Root>
        <Header.LogoContainer>
          <Logo alt="Zenbusiness Velo" height={logoHeight} src={logoSrc} />
        </Header.LogoContainer>
        {(title || subtitle) && (
          <Header.ContentContainer>
            {title && <Header.Title>{title}</Header.Title>}
            {subtitle && <Header.Subtitle>{subtitle}</Header.Subtitle>}
          </Header.ContentContainer>
        )}
      </Header.Root>
    </Header.Background>
  );
}

StandaloneHeader.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  logoSrc: PropTypes.string,
  logoHeight: PropTypes.number
};
